import { types } from 'mobx-state-tree';
import Actions from './actions';
import Views from './views';
const Calendar = types
    .model({
    isCalendarEnabled: types.optional(types.boolean, false),
    isExtensionPermissionEnabled: false,
    isLoaded: types.optional(types.boolean, false),
    integrationId: types.optional(types.number, 0),
})
    .views(Views)
    .actions(Actions);
export default Calendar;
